module.exports = "/_next/static/images/496ed29fa043b42d060c6205b9286153-promo-amazon-day.jpg";